import React from 'react';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {translations} from 'presentation/translations-new';
import {BookingFlowLayout} from '../../components/BookingFlowLayout';

import {ODONTO_LABELS, ODONTO_LABELS_WITHOUT_DISTRICT} from './constants';
import {useBackButtonBooking} from 'presentation/modules/booking/shared/hooks/useBackButtonBooking';
import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {bookOdonto} = translations['pt-br'].privateFlow.services;

export function OdontoBooking() {
	const bookingData = useBookingStore(state => state.bookingData);
	const isUsingGeolocation = !bookingData.isManualLocation;

	useBackButtonBooking({flowType: BookingTypeEnum.ODONTO});

	return (
		<BookingFlowLayout
			flowType={FlowEnum.ODONTO}
			headerTitle={bookOdonto}
			stepLabels={isUsingGeolocation ? ODONTO_LABELS_WITHOUT_DISTRICT : ODONTO_LABELS}
		/>
	);
}
